// External Libraries
import React from "react";
import * as Icon from "react-feather";
import moment from "moment";

// Services
import UserService from "../../services/UserService";

// Components
import TeamModal from "./TeamModal";

// Common Components
import WComponent from "../common/WComponent";
import Loader from "../common/loader/Loader";
import clsx from "clsx";
import SearchInput from "../common/search_input/SearchInput";
import Button from "../common/button/Button";
import RestrictedAccess from "../common/restricted_access/RestrictedAccess";
import UtilityService from "../../services/UtilityService";

class Teams extends WComponent {
	constructor() {
		super();
		this.state = {
			search: "",
			loading: false,

			teams: [],
			sortedField: "name",
			desc: true,

			showTeamModal: false,
			teamId: "new",
			isNotAllowedResource: false
		};
	}

	componentDidMount() {
		this.resetComponent();
	}

	async resetComponent() {
		await this.update({
			loading: true
		});

		await this.fetchTeams();

		this.update({
			loading: false
		});
	}

	async fetchTeams() {
		let { search } = this.state;

		let teams = await UserService.fetchTeams({ search });

		if(UtilityService.isNotAllowedResource({response : teams}))
		{
			await this.update({
				isNotAllowedResource : true
			});	
			return;		
		}

		this.update({
			teams
		});
	}

	switchView(view) {
		this.update({
			currentView: view
		});
	}

	onNewTeam = () => {
		this.update({
			teamId: "new",
			showTeamModal: true
		});
	};

	onTeamModalClose = async () => {
		await this.update({
			showTeamModal: false
		});

		await this.fetchTeams();
	};

	sortBy() {}

	renderSortIcon(field) {
		return this.state.sortedField === field && (this.state.desc ? <Icon.ChevronUp size={14} /> : <Icon.ChevronDown size={14} />);
	}

	onSearch = async event => {
		await this.update({ search: event.target.value });
		await this.fetchTeams();
	};

	onOpenTeam = async teamId => {
		await this.update({
			showTeamModal: true,
			teamId
		});
	};

	render() {
		let { teams, loading, search, teamId, showTeamModal, isNotAllowedResource } = this.state;

		if (isNotAllowedResource)
		{					
			return <RestrictedAccess/>
		}

		return (
			<>
				<div className="teams__team-view__header">
					<Button view="secondary" onClick={this.onNewTeam} icon={<Icon.Plus size={18} />} className="ft-team-add-btn"/>

					<SearchInput placeholder="Search..." value={search} onChange={this.onSearch} className="ft-team-search-btn"/>
				</div>

				{loading && (
					<div className="container-loader">
						<Loader />
					</div>
				)}

				{teams.length > 0 && !loading && (
					<div className={clsx("t", "t--compact", "ft-teams-table")}>
						<div className="t__header">
							<div onClick={() => this.sortBy("name")} className="t__header__item">
								Name {this.renderSortIcon("name")}
							</div>
							<div onClick={() => this.sortBy("description")} className="t__header__item">
								Description {this.renderSortIcon("description")}
							</div>
							<div onClick={() => this.sortBy("date")} className="t__header__item">
								Creation Date {this.renderSortIcon("date")}
							</div>
						</div>

						{teams.map((team, index) => {
							let odd = index % 2 === 0;

							return (
								<div className={clsx("t__row", { "t__row--stripe": odd }, "ft-team-row")} key={index} data-teamid={team.id}>
									<div className={clsx("t__row__item", "ft-team-name-column")} onClick={() => this.onOpenTeam(team.id)}>
										{team.name}
									</div>
									<div className={clsx("t__row__item", "ft-team-description-column")}>{team.description}</div>
									<div className={clsx("t__row__item","ft-team-created-column")}>{moment(team.created_at).format("LL")}</div>
								</div>
							);
						})}
					</div>
				)}
				<TeamModal show={showTeamModal} teamId={teamId} onClose={this.onTeamModalClose} {...this.props} />
			</>
		);
	}
}

export default Teams;
